import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify'
import ProfileForm from 'components/Profile/Profile';
import ChangePasswordForm from 'components/Authorization/ChangePassword/ChangePassword.jsx';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator.js';
import moment from 'moment';

const {
  ERROR_TYPE_USER_UPDATE_ERROR,
  CHANGE_PASSWORD_SAGA
} = constants;

const {
  loadCurrentUser,
  updateUserSaga,
  addValidateError,
  cleanErrors,
  changePasswordSaga
} = actions;

class Profile extends Component {

  constructor(props) {
    super(props);
    const user = this.props.user;
    this.fillProfileNotificationId = null;
    this.state = {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        user_type: '',
        phone: null,
        imc: '',
        gender: '',
        registration: '',
        county: '',
        practice_name: '',
        hospital: '',
        role: '',
        title: '',
        ...user,
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      passwordChange: {
        id: user.id,
        email: user.email,
        password: '',
        password_confirmation: '',
        old_password: '',
      },
      passwordVisibility: {
        password: false,
        password_confirmation: false,
        old_password: false,
      }
    }
  }

  componentWillMount() {
    this.props.loadCurrentUser();
    this.props.cleanErrors();
    this.props.cleanErrorsPasswordChange();
    this.notifyAccountFill();
  }

  componentWillUnmount() {
    this.closeAccountFillNotification();
  }

  componentWillReceiveProps(nextProps) {
    nextProps.user.is_valid && this.closeAccountFillNotification();
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.updateUser(this.state.user);
  }

  onSubmitPasswordChange = (e) => {
    e.preventDefault();
    this.props.changePassword(this.state.passwordChange);
  }

  onFieldChange = (e) => {
    const userData = { ...this.state.user,
      ...{
        [e.target.name]: e.target.value
      }
    }

    this.setState({ user: userData })//, this.validateUser);
  }

  onPasswordChangeVisibility = (field, value) => {
    this.setState({
      passwordVisibility: {
        ...this.state.passwordVisibility,
        [field]: value
      }
    })
  }

  onPasswordsFieldChange = (e) => {
    const passwordChangeData = { ...this.state.passwordChange,
      ...{
        [e.target.name]: e.target.value
      }
    }

    this.setState({ passwordChange: passwordChangeData })//, this.validatePasswordChange);
  }


  onRoleChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ user_type: e.target.value }
    }
    this.setState({ user: userData });
  }

  validateUser = () => {
    this.props.validateUser(
      validator.validate(this.state.user, 'userProfile')
    )
  }

  validatePasswordChange = () => {
    this.props.validatePasswordChange(
      validator.validate(this.state.passwordChange, 'newPassword')
    )
  }

  onCountyChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{ county: e.value }
    }
    this.setState({ user: userData });
  }

  roleFields = () => {
    switch (this.state.user.user_type) {
      case 'gp':
        return ['imc', 'practice_name']
      case 'gp_trainee':
        return ['imc', 'practice_name']
      case 'consultant':
        return ['imc', 'hospital']
      case 'hospital_doctor':
        return ['imc', 'hospital']
      case 'practice_nurse':
        return ['registration', 'practice_name' ]
      case 'nurse_specialist':
        return ['registration', 'imc' ]
      default: return []
    }
  }

  notifyAccountFill = () => {
    if(this.props.user.is_valid == false)
      this.fillProfileNotificationId = toast.warn(
        'Please complete your profile', {
          autoClose: false
        }
      );
  }

  closeAccountFillNotification = () => {
    this.fillProfileNotificationId && toast.dismiss(this.fillProfileNotificationId);
  }

  render() {
    const {
      errors,
      errorsFrontend,
      passwordChangeErrors,
      passwordChangeErrorsFrontend
    } = this.props;

    const outErrors = Object.keys(errorsFrontend || {}).length ? errorsFrontend : errors;
    const outErrorsPasswordChange = Object.keys(passwordChangeErrorsFrontend || {}).length ?
      passwordChangeErrorsFrontend :
      errors;
    return (
      <main className="site--width">
        <h2 className="main_title">
          PROFILE
        </h2>
        <ProfileForm
          user={this.state.user}
          onFieldChange={this.onFieldChange}
          onSubmit={this.onSubmit}
          errors={outErrors || {}}
          onRoleChange={this.onRoleChange}
          roleFields={this.roleFields()}
          onCountyChange={this.onCountyChange}
          is_admin={false}
        />
        <h2 className="main_title" id="change_password">
          CHANGE PASSWORD
        </h2>
        <ChangePasswordForm
          user={this.state.passwordChange}
          onFieldChange={this.onPasswordsFieldChange}
          onSubmit={this.onSubmitPasswordChange}
          errors={outErrorsPasswordChange || {}}
          passwordVisibility={this.state.passwordVisibility}
          onPasswordChangeVisibility={this.onPasswordChangeVisibility}
        />
      </main>
    )
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ERROR_TYPE_USER_UPDATE_ERROR],
  errorsFrontend: state.errors[`${ERROR_TYPE_USER_UPDATE_ERROR}_FRONTEND`],
  user: state.users.user,
  passwordChangeErrors: state.errors[CHANGE_PASSWORD_SAGA],
  passwordChangeErrorsFrontend: state.errors[`${CHANGE_PASSWORD_SAGA}_FRONTEND`],
});

const mapDispatchToProrp = (dispatch) => ({
  loadCurrentUser: () => dispatch(loadCurrentUser()),
  updateUser: (user) => dispatch(updateUserSaga(user)),
  validateUser: (errors) => dispatch(addValidateError(ERROR_TYPE_USER_UPDATE_ERROR, errors)),
  cleanErrors: () => dispatch(cleanErrors(ERROR_TYPE_USER_UPDATE_ERROR)),
  validatePasswordChange: (errors) => dispatch(addValidateError(CHANGE_PASSWORD_SAGA, errors)),
  cleanErrorsPasswordChange: () => dispatch(cleanErrors(CHANGE_PASSWORD_SAGA)),
  changePassword: (changePasswordData) => dispatch(changePasswordSaga(changePasswordData))
})
export default connect(mapStateToProps, mapDispatchToProrp)(Profile);



/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Profile.js
 **/